import React, { FunctionComponent } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
// import { useAtom } from 'jotai';

// import { loginAtom, renew_sign_in } from '../../lib/auth';

import Close from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Visibility from '@mui/icons-material/Visibility';

import {
  Avatar,
  Box,
  Tooltip,
} from '@mui/material';

import {
  Button,
  IconButton,
  Typography
} from '../../../../components/v2/styled';

import { KnowledgeCourse } from '../../../../models/KnowledgeCourse';
import { KnowledgeLesson } from '../../../../models/KnowledgeLesson';
import { KnowledgeSubject } from '../../../../models/KnowledgeSubject';

import HelpersKnowledge from '../../../../actions/helpers/knowledge';
import HelpersLanguage from '../../../../actions/helpers/language';

// const { DateTime } = require("luxon");

type Props = {
  knowledgeCourse: KnowledgeCourse;
  knowledgeSubject: KnowledgeSubject;
  knowledgeLesson: KnowledgeLesson;
  i: number;
  setLessonEditingId?: (n:number) => void;
  setLessonEditOpen?: (b:boolean) => void;
  setActiveSubject?: (k:KnowledgeSubject) => void;
  mutationDestroy?: any;
  sx?: any;
  disabled?: boolean;
  completed?: boolean;
  showAccessDaysMessage?: boolean;
  showAccessDays?: string;
  play?: boolean;
  startLesson?: () => void;
};

export const StyledKnowledgeLesson: FunctionComponent<Props> = ({knowledgeCourse, startLesson, completed, sx, disabled, showAccessDaysMessage, showAccessDays, play, knowledgeSubject, knowledgeLesson, setActiveSubject, i, setLessonEditingId, setLessonEditOpen, mutationDestroy}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  const {t, i18n} = useTranslation(['translations']);








  const selectContentWithId = (field?:{[z:string]: string}, extraFallback?:string) => {
    let correct = (field || {})[HelpersLanguage.mapping_to_id(i18n.resolvedLanguage || 'nl')];
    if (!!correct) return correct;
    let fallback = (field || {})['nl'];
    if (!!fallback) return fallback;
    let anyFallback = Object.values(field || {}).filter(fff => !!fff)[0];
    if (!!anyFallback) return anyFallback;
    if (!!extraFallback) return extraFallback;
    return t("general.translation_fallbacks.no_translation_available")
  }







  return (<Box sx={{
    padding: 2,
    border: '1px solid transparent',
    borderColor: !!disabled ? 'lightgrey' : theme.palette.primary.main,
    borderRadius: 1,
    position: 'relative',
    paddingLeft: 10,
    paddingRight: 12,
    ...sx
  }}>
    <Avatar sx={{position: 'absolute', top: 8, left: 8, backgroundColor: !!disabled ? 'lightgrey' : theme.palette.primary.main}}>{HelpersKnowledge.doNumerals(knowledgeSubject?.extra_data?.numerals || 'normal', i+1)}</Avatar>
    <Typography variant="h5" sx={{
      ...(!!disabled ? {
        color: 'lightgrey'
      } : {})
    }}>{selectContentWithId(knowledgeLesson.full_name || {}, knowledgeLesson?.name)}</Typography>
    {!startLesson && parseInt(knowledgeLesson?.access_data?.day_from_start || "0", 10) > 0 && <Tooltip title={t("general.knowledge_lessons.explanation.access_day_from_start")}><Avatar
      children={`S+${knowledgeLesson?.access_data?.day_from_start}`}
      sx={{
        position: 'absolute',
        top: 8,
        right: 108,
        fontSize: '0.8rem',
        backgroundColor: theme.palette.primary.main
      }}
    /></Tooltip>}
    {!!showAccessDaysMessage && <Typography variant="h5" sx={{
      color: theme.palette.secondary.main,
      fontSize: '0.8rem',
      fontStyle: 'italic'
    }}>{t("general.knowledge_lessons.explanation.lesson_available_from", {date: showAccessDays})}</Typography>}
    {!!setLessonEditingId && !!setLessonEditOpen && !!setActiveSubject && <IconButton title="Edit" color="default" onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();

      setLessonEditingId(knowledgeLesson.id || 0);
      setActiveSubject(knowledgeSubject);
      setLessonEditOpen(true);
    }} sx={{
      position: 'absolute',
      top: 8,
      right: 52
    }}>
      <EditIcon />
    </IconButton>}
    {!!mutationDestroy && <IconButton destroyBtn title="Destroy" color="secondary" onClick={() => {
      mutationDestroy.mutate({
        formData: {
          object: 'knowledge_lesson',
          id: knowledgeLesson.id,
          ob: {
            id: knowledgeLesson.id,
          }
        }
      });
    }} sx={{
      position: 'absolute',
      top: 8,
      right: 8
    }}>
      <DeleteIcon />
    </IconButton>}
    {!!disabled && !completed && <IconButton title="Disabled" onClick={() => {
      
    }} sx={{
      position: 'absolute',
      top: 8,
      right: 8
    }} disabled>
      <Close />
    </IconButton>}
    {!!disabled && !!completed && <IconButton title="View again" onClick={() => {
      if (!!startLesson) startLesson();
    }} sx={{
      position: 'absolute',
      top: 8,
      right: 8
    }}>
      <Visibility />
    </IconButton>}
    {!!play && <Button
      label={t(knowledgeCourse.course_type === 1 ? "client.course.actions.start_knowledge" : "client.course.actions.start_lesson")}
      id="start_lesson"
      color="primary"
      onClick={() => {
        if (!!startLesson) startLesson();
      }}
      startIcon={<PlayArrowIcon />}
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
        border: '1px solid transparent',
        borderColor: theme.palette.primary.main,
        marginTop: 0,
        display: {
          xs: 'none',
          md: 'inline-flex'
        }
      }}
    />}
    {!!play && <IconButton
      color="primary"
      onClick={() => {
        if (!!startLesson) startLesson();
      }}
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
        border: '1px solid transparent',
        borderColor: theme.palette.primary.main,
        marginTop: 0,
        display: {
          xs: 'inline-flex',
          md: 'none'
        },
        height: '42px'
      }}
    ><PlayArrowIcon /></IconButton>}
  </Box>);
}
